export default axios => ({
  getFile(fileId) {
    return axios.get(`file/get/${fileId}`, {
      responseType: 'arraybuffer'
    });
  }
})
